<template>
  <div class="third-party-cmp" @click="hiddenLanguageOptions">
    <switch-i18n ref="i18nRef" />
    <div class="article-wrapper">
      <h1>{{ appName }}{{ $t('common.thirdPartyTitle') }}</h1>
      <slot name="app-desc"></slot>
      <p>{{ $t('common.thirdParty01') }}</p>
      <p>{{ $t('common.thirdParty02') }}</p>
      <h2>{{ $t('common.thirdPartyTitle01') }}</h2>
      <p>{{ $t('common.thirdParty03') }}</p>
      <p>{{ $t('common.thirdParty04') }}</p>
      <p>{{ $t('common.thirdParty05') }}</p>
      <p>{{ $t('common.thirdParty06') }}</p>
      <h2>{{ $t('common.thirdPartyTitle02') }}</h2>
      <p>{{ $t('common.thirdParty07') }}</p>
      <p>{{ $t('common.thirdParty08') }}</p>
      <p>{{ $t('common.thirdParty09') }}</p>
      <p>{{ $t('common.thirdParty10') }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useTitle } from '@/hooks/useTitle'
import { useHideLanguageOptions } from '@/hooks/useHideLanguageOptions';
import SwitchI18n from "@/components/switch_i18n.vue"

// 定义属性
defineProps({
  appName: {
    type: String,
    default: '',
  },
});

// 监听到语言发生改变后修改标题
useTitle('common.thirdPartyTitle');

// 点击空白区域隐藏语言选择框
const { i18nRef, hiddenLanguageOptions } = useHideLanguageOptions();
</script>

<style lang="less">
</style>
